import { TWhiteLabelStore } from '../white-label.model';

export function setPanelTextHover(
  themeWrapper: HTMLBodyElement,
  whiteLabel: TWhiteLabelStore,
): void {
  themeWrapper.style.setProperty('--panelTextHover', whiteLabel.data.panelTextHover);
}
